import Vue from "vue";
import Component from "vue-class-component";
import { PersonneAChargeDto } from "../../../../dto/GenApi.iNotPaie.Dto/PersonneAChargeDto";
import $ from "jquery";
import moment from "moment";

@Component({
	components: {
		Input: require("../../../../atomicComponents/Input/Input.vue.html")
	}
})
export default class ModalAjoutEditPersonnes extends Vue {
	public typePersonne = "";
	public personne?: PersonneAChargeDto = undefined;
	public estAjout = false;

	public nom?: string = "";
	public prenom?: string = "";
	public dateNaissance?: string = undefined;
	public lieuNaissance?: string = "";
	public profession?: string = "";
	public sexe?: string = "";
	public dateFin?: string = undefined;

	public onPersonneChange(): void {
    	if (this.personne == undefined) {
			return;
		}

    	this.nom = this.personne.Nom;
    	this.prenom = this.personne.Prenom;
    	this.dateNaissance = this.personne.DateNaissance != undefined ? moment.utc(this.personne.DateNaissance).format("YYYY-MM-DD") : "";
    	this.lieuNaissance = this.personne.LieuNaissance;
    	this.profession = this.personne.Profession;
    	this.sexe = this.personne.Sexe;
    	this.dateFin = this.personne.DateFin != undefined ? moment.utc(this.personne.DateFin).format("YYYY-MM-DD") : "";
	}

	public initialize(personne: PersonneAChargeDto, type: string, estAjout: boolean): void {
    	this.personne = personne;
    	this.typePersonne = type;
    	this.estAjout = estAjout;
    	this.onPersonneChange();

    	this.$forceUpdate();
	}

	public enregistrer(): void {
		if (this.personne == undefined || this.nom == undefined || this.nom == "") {
			return;
		}

    	this.personne.Nom = this.nom;
    	this.personne.Prenom = this.prenom;
    	this.personne.DateNaissance = this.dateNaissance != "" ? moment.utc(this.dateNaissance).toDate() : undefined;
    	this.personne.LieuNaissance = this.lieuNaissance;
    	this.personne.Profession = this.profession;
    	this.personne.Sexe = this.sexe;
    	this.personne.DateFin = this.dateFin != "" ? moment.utc(this.dateFin).toDate() : undefined;

    	this.$emit(this.estAjout ? "ajout" : "update", { personne: this.personne, type: this.typePersonne });

    	$("#modalAjoutEditPersonnes").modal("hide");
	}

	public annuler(): void {
    	$("#modalAjoutEditPersonnes").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/declarations/ajoutEditPersonne/modalAjoutEditPersonnes.ts